import { atom } from 'recoil';

export { dashboardGPAAtom, dashboardLevelGPAAtom, dashboardFilterGPAAtom, dashboardGPAStatusAtom, dashboardLevelStatusAtom };

const dashboardGPAAtom = atom({
    key: {
        name: 'GPA'
    },
    default: []
});

const dashboardLevelGPAAtom = atom({
    key: {
        name: 'levelGPA'
    },
    default: {
        data: []
    }
});

const dashboardFilterGPAAtom = atom({
    key: {
        name: 'filterGPA'
    },
    default: 'nofilter'
});

const dashboardGPAStatusAtom = atom({
    key: 'GPAStatus',
    default: []
});

const dashboardLevelStatusAtom = atom({
    key: 'levelGPAStatus',
    default: {
        data: []
    }
});

